import find from "lodash/find";
import t from "./translate";

export const PATIENT_URL = "https://servers.techconnect.cl/MPI/Patient";
export const PRACTITIONER_URL =
  "https://servers.techconnect.cl/HPD/Practitioner";

export async function searchByRut(type, rut) {
  const baseUrl =
    type === "patient"
      ? `${PATIENT_URL}?identifier=www.registrocivil.cl/RUN|`
      : `${PRACTITIONER_URL}?_profile=http://cens.cl/fhir/StructureDefinition/Practitioner-cl&getPractitionerByIdentificationNumber=`;

  return fetch(`${baseUrl}${rut}`).then((response) => response.json());
}

export async function fetchReferenceValues(code) {
  function getValueKey(param) {
    return Object.keys(param).find((key) => key.startsWith("value"));
  }

  function getParam({ parameter }, name) {
    return find(
      parameter,
      (param) => param.part && param.part[0].valueCode === name
    );
  }

  function getParamValue(parameters, name) {
    const param = getParam(parameters, name);
    if (!param) return "-";

    const valuePart = param.part[1];
    return valuePart[getValueKey(valuePart)];
  }

  function displayRange(minRange, maxRange) {
    const min = parseFloat(minRange);
    const max = parseFloat(maxRange);
    const isMinNumber = !isNaN(min);
    const isMaxNumber = !isNaN(max);

    if (!isMinNumber && !isMaxNumber) return null;

    if (isMinNumber && isMaxNumber) {
      if (min === 0) return `Hasta ${max}`;
      return `Desde ${min} hasta ${max}`;
    }

    if (isMinNumber) {
      return `Superior a ${min}`;
    }

    return `Inferior a ${max}`;
  }

  return fetch(
    `https://servers.techconnect.cl/ST/CodeSystem/$lookup?system=http://cens.cl/lab-ref-ranges&code=${code}`
  )
    .then((res) => res.json())
    .then((data) => {
      const unit = getParamValue(data, "unit");
      const range = displayRange(
        getParamValue(data, "min-range"),
        getParamValue(data, "max-range")
      );
      return {
        unit,
        range: range && `${range} ${unit.code}`,
      };
    });
}

export async function questionnaireFetcher(id) {
  return fetch(`https://servers.techconnect.cl/ST/Questionnaire/${id}`)
    .then((response) => response.json())
    .then(async (resource) => {
      return {
        id: resource.code[0].code,
        code: resource.code,
        questions: await Promise.all(
          resource.item.map(async ({ code, text, required }) => {
            const id = code[0].code;
            const referenceValues = await fetchReferenceValues(id);
            return {
              id,
              name: t(id, text),
              required: !!required,
              display: text,
              code,
              ...referenceValues,
            };
          })
        ),
      };
    });
}
